import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "MENU.DASHBOARD",
    icon: "fas fa-chart-pie",
    link: "/dashboard",
    profilesAllowed: [
      "ADMINISTRATOR",
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
    ],
  },
  {
    id: 2,
    label: "MENU.MAP",
    icon: "fas fa-map-marked-alt",
    link: "/all-map",
    profilesAllowed: [
      "ADMINISTRATOR",
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
    ],
  },
  {
    id: 12,
    label: "MENU.SERVICE_ORDERS",
    icon: "far fa-list-alt",
    profilesAllowed: [
      "ADMINISTRATOR",
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
      "SERVICE_PROVIDER_ATTENDANT",
      "ATTENDANT",
    ],
    subItems: [
      {
        id: 1,
        label: "MENU.SERVICE_ORDERS_SEARCH",
        link: "/registration/service-orders",
        parentId: 12,
      },
      {
        id: 2,
        label: "MENU.UNROUTED_SERVICE_ORDERS",
        link: "/service-orders/unrouted-service-orders",
        parentId: 12,
      },
    ],
  },
  {
    id: 3,
    label: "MENU.ROUTES",
    icon: "fas fa-route",
    link: "/routes/routing",
    profilesAllowed: [
      "ADMINISTRATOR",
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
    ],
    subItems: [
      {
        id: 4,
        label: "MENU.NEW_ROUTE",
        link: "/routes/new/service-orders",
        parentId: 3,
        profilesAllowed: [
          "ADMINISTRATOR",
          "SERVICE_PROVIDER",
          "SERVICE_PROVIDER_TECHNICIAN",
        ],
      },
      // {
      //   id: 5,
      //   label: "Rotas automáticas",
      //   link: "/routes/automatic",
      //   parentId: 3,
      // },
      // {
      //     id: 6,
      //     label: 'Workpack',
      //     link: '/routes/workpack',
      //     parentId: 3
      // },
      // {
      //   id: 7,
      //   label: "Gerenciar",
      //   link: "/routes/management",
      //   parentId: 3,
      // },
      {
        id: 7,
        label: "MENU.GENERATED_ROUTES",
        link: "/routes/all",
        parentId: 3,
        profilesAllowed: [
          "ADMINISTRATOR",
          "SERVICE_PROVIDER",
          "SERVICE_PROVIDER_TECHNICIAN",
        ],
      },
    ],
  },
  {
    id: 8,
    label: "MENU.REGISTRATIONS",
    icon: "fas fa-globe-americas",
    profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
    subItems: [
      {
        id: 12,
        label: "MENU.SERVICE_AREA",
        link: "/registration/area-of-service",
        parentId: 8,
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
      // {
      //   id: 14,
      //   label: "Ordens de Serviço",
      //   link: "/registration/service-orders",
      //   parentId: 8,
      // },
      {
        id: 9,
        label: "MENU.TECHNICIANS",
        link: "/registration/technician",
        parentId: 8,
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
      {
        id: 10,
        label: "MENU.USERS",
        link: "/registration/user",
        parentId: 8,
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
      {
        id: 13,
        label: "MENU.SERVICE_GROUPS",
        link: "/registration/service-group",
        parentId: 8,
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
      {
        id: 13,
        label: "MENU.SERVICES",
        link: "/registration/service",
        parentId: 8,
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
    ],
  },
  {
    id: 14,
    label: "MENU.ADOPTION_REPORT",
    icon: "fas fa-chart-line",
    link: "/adoption-report",
    profilesAllowed: ["ADMINISTRATOR"],
  },
  {
    id: 15,
    label: "MENU.TRAINING",
    icon: "fas fa-graduation-cap",
    link: "/training",
    profilesAllowed: [
      "ADMINISTRATOR",
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
      "SERVICE_PROVIDER_ATTENDANT",
      "ATTENDANT",
    ],
  },
  {
    id: 11,
    label: "MENU.SETTINGS",
    icon: "fas fa-cogs",
    link: "/config",
    profilesAllowed: [
      "SERVICE_PROVIDER",
      "SERVICE_PROVIDER_TECHNICIAN",
      "ADMINISTRATOR",
    ],
    subItems: [
      {
        id: 11,
        label: "MENU.GENERAL",
        link: "/config/general",
        profilesAllowed: ["SERVICE_PROVIDER", "SERVICE_PROVIDER_TECHNICIAN"],
      },
      {
        id: 13,
        label: "MENU.STATUS_BASED_ACTION",
        link: "/config/status-based-action",
        profilesAllowed: ["ADMINISTRATOR"],
      },
    ],
  },
];
